import type { KeyboardEvent } from 'react';
import Autocomplete, {
    type AutocompleteProps
} from '@mui/material/Autocomplete';
import { useTabTakesSuggestion } from './tabTakesSuggestion';

type TabSuggestAutocompleteProps = AutocompleteProps<
    string,
    false,
    boolean | undefined,
    boolean | undefined
> & {
    /** Writes the suggestion a Tab (or an arrow-picked Enter) takes. */
    onTake: (option: string, event: KeyboardEvent<HTMLDivElement>) => void;
};

/**
 * A single-value Autocomplete over strings with the Tab rule of
 * `useTabTakesSuggestion` — for the fields that build their Autocomplete in a
 * render callback, where the hook itself cannot be called.
 */
export default function TabSuggestAutocomplete({
    onTake,
    filterOptions,
    onInputChange,
    onKeyDown,
    ...props
}: TabSuggestAutocompleteProps) {
    const suggestion = useTabTakesSuggestion(filterOptions);
    return (
        <Autocomplete
            {...props}
            {...suggestion.autocompleteProps}
            onInputChange={(event, value, reason) => {
                suggestion.noteInput(reason);
                onInputChange?.(event, value, reason);
            }}
            onKeyDown={(event) => {
                onKeyDown?.(event);
                const taken = suggestion.keyDown(event);
                if (taken !== undefined) {
                    onTake(taken, event);
                }
            }}
        />
    );
}
